import axios from "axios";
import { url } from "../baseUrl";

export const TeamStore = {
  state: {
    all: []
  },
  mutations: {},
  actions: {
    createTeam(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/accounts/teams/",
          data: {
            name: data
          },
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "POST"
        })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    deleteTeam(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/idm/deleteteam/",
          data: data,
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "POST"
        })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
